var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderTwoDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1467,
    height: 1043,
    viewBox: "0 0 1467 1043",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loaderTwo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 19",
    filter: "url(#filter0_b_18_5960)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1467,
    height: 1043,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4",
    filter: "url(#filter1_b_18_5960)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 737,
    y: 216,
    width: 287,
    height: 91,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 97",
    filter: "url(#filter2_b_18_5960)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 737,
    y: 324,
    width: 287,
    height: 91,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 101",
    filter: "url(#filter3_b_18_5960)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 737,
    y: 432,
    width: 287,
    height: 91,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 95",
    x: 215,
    y: 282,
    width: 404,
    height: 29,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 90",
    x: 758,
    y: 246,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 98",
    x: 758,
    y: 354,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 102",
    x: 758,
    y: 462,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 96",
    x: 929,
    y: 246,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 99",
    x: 929,
    y: 354,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 103",
    x: 929,
    y: 462,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 92",
    x: 857,
    y: 239,
    width: 46,
    height: 43,
    rx: 21.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 100",
    x: 857,
    y: 347,
    width: 46,
    height: 43,
    rx: 21.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 104",
    x: 857,
    y: 455,
    width: 46,
    height: 43,
    rx: 21.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 108",
    x: 621,
    y: 823,
    width: 46,
    height: 43,
    rx: 21.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 76",
    x: 456,
    y: 733,
    width: 351,
    height: 80,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 106",
    x: 215,
    y: 827,
    width: 111,
    height: 36,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 107",
    x: 335,
    y: 827,
    width: 278,
    height: 36,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 105",
    x: 215,
    y: 666,
    width: 232,
    height: 147,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 78",
    x: 995,
    y: 800,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 80",
    x: 1173,
    y: 800,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 79",
    x: 995,
    y: 838,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 81",
    x: 1173,
    y: 838,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_18_5960",
    x: -200,
    y: -200,
    width: 1867,
    height: 1443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_5960"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_5960",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_18_5960",
    x: 731,
    y: 210,
    width: 299,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_5960"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_5960",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_18_5960",
    x: 731,
    y: 318,
    width: 299,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_5960"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_5960",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_18_5960",
    x: 731,
    y: 426,
    width: 299,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_5960"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_5960",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderTwoDesktop);
export default __webpack_public_path__ + "static/media/loader-two-desktop.45823472296eb18868191981d6f99122.svg";
export { ForwardRef as ReactComponent };